/** Rechtslinks für alle Fußbereiche — Startseite, Anmeldung, Registrierung, Tarif. */
export const RECHTSLINKS: Array<[string, string]> = [
  ['/impressum', 'Impressum'], ['/datenschutz', 'Datenschutz'], ['/agb', 'AGB'],
  ['/kontakt', 'Kontakt'], ['/kuendigen', 'Verträge hier kündigen'],
];
